'use client'
import React from 'react'

type Props = {
    is1kg: boolean,
    setIs1kg: React.Dispatch<React.SetStateAction<boolean>>,
    is1kgPricePresent: boolean
}

const WeightSelector = ({ is1kg, setIs1kg, is1kgPricePresent }: Props) => {
    return (
        <div className='flex gap-4 mt-2 items-center'>
            <p className='text-sm text-gray-500'>Net Weight:</p>
            <div className="flex gap-4 text-sm text-gray-700 items-center font-semibold">
                <label
                    className={`flex items-center gap-2 cursor-pointer px-3 py-2 rounded-xl hover:outline hover:outline-1 hover:outline-amber-500 ${!is1kg ? 'outline-amber-500 outline outline-1 bg-amber-50' : 'bg-[#fdfcfd]'}`}
                >
                    <input
                        type="radio"
                        name="weight"
                        value="0.5"
                        checked={!is1kg}
                        onChange={() => setIs1kg(false)}
                        className="accent-black"
                    />
                    1 lb <span className='text-xs text-gray-700 font-normal sm:flex hidden'>(450 g)</span>
                </label>

                {
                    is1kgPricePresent &&
                    <label
                        className={`flex items-center gap-2 cursor-pointer px-3 py-2 rounded-xl hover:outline hover:outline-1 hover:outline-amber-500 ${is1kg ? 'outline-amber-500 outline outline-1 bg-amber-50' : 'bg-[#fdfcfd]'}`}
                    >
                        <input
                            type="radio"
                            name="weight"
                            value="1"
                            checked={is1kg}
                            onChange={() => setIs1kg(true)}
                            className="accent-black"
                        />
                        2.2 lb <span className='text-xs text-gray-700 font-normal sm:flex hidden'>(1000 g - Suitable for Vending Machines)</span>
                    </label>
                }
            </div>
        </div>
    )
}

export default WeightSelector
